import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const TEXTBLOCK_LEGACY_FIELD_ORDER = [
  "content",
  { type: 'separator' },
  "width",
  "top_margin",
  "bottom_margin",
  { type: 'separator' },
  "without_padding",
  "without_container",
  "text_color"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  textBlockDescriptor: _generatedTextBlockDescriptor,
  textBlockBlocDefinition,
  textBlockDashboardLayout,
  textBlockConfig,
  textBlockResolveConfig,
  textBlockProperties,
} = doodBlockConfig(
  {
    name: "Text",
    componentType: 'TextBlockComponent',
    category: 'content',
    description: "Text.",
    keywords: [],
    sharedFields: {}
  },

  () => ({
    content: propertyValue({
      type: 'wysiwyg',
      value: '',
      options: {
        label: "pages.blocks.text.content.label",
      }
    }),
    width: propertyValue({
      type: 'select',
      value: "small",
      options: {
        label: "pages.blocks.text.width.label",
        choices: [
          {
            value: "small",
            label: "pages.blocks.text.width.options.small",
          },
          {
            value: "full",
            label: "pages.blocks.text.width.options.full",
          }
        ]
      }
    }),
    top_margin: propertyValue({
      type: 'select',
      value: "none",
      options: {
        label: "pages.blocks.text.top-margin.label",
        choices: [
          {
            value: "none",
            label: "pages.blocks.text.top-margin.options.none",
          },
          {
            value: "small",
            label: "pages.blocks.text.top-margin.options.small",
          },
          {
            value: "medium",
            label: "pages.blocks.text.top-margin.options.medium",
          },
          {
            value: "large",
            label: "pages.blocks.text.top-margin.options.large",
          }
        ]
      }
    }),
    bottom_margin: propertyValue({
      type: 'select',
      value: "medium",
      options: {
        label: "pages.blocks.text.bottom-margin.label",
        choices: [
          {
            value: "none",
            label: "pages.blocks.text.bottom-margin.options.none",
          },
          {
            value: "small",
            label: "pages.blocks.text.bottom-margin.options.small",
          },
          {
            value: "medium",
            label: "pages.blocks.text.bottom-margin.options.medium",
          },
          {
            value: "large",
            label: "pages.blocks.text.bottom-margin.options.large",
          }
        ]
      }
    }),
    without_padding: propertyValue({
      type: 'checkbox',
      value: false,
      options: {
        label: "pages.blocks.text.without-padding.label",
        help: "pages.blocks.text.without-padding.help",
      }
    }),
    without_container: propertyValue({
      type: 'checkbox',
      value: false,
      options: {
        label: "pages.blocks.text.without-container.label",
        help: "pages.blocks.text.without-container.help",
      }
    }),
    text_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-800"},
      options: {
        label: "pages.blocks.text.text-color.label",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.text.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.text.fieldset.text.label",
            fields: ["content", "text_color"],
          },
          {
            legend: "pages.blocks.text.fieldset.layout.label",
            fields: [
              "width",
              "top_margin",
              "bottom_margin",
              "without_padding",
              {
                prop: "without_container",
                visibleWhen: { width: "small" },
              },
            ],
          },
        ],
      },
    ],
  })
);

export function textBlockDescriptor(): IBlockDescriptor;
export function textBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function textBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedTextBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedTextBlockDescriptor, textBlockProperties, fieldOrder);
}

export {
  textBlockBlocDefinition,
  textBlockDashboardLayout,
  textBlockProperties,
  textBlockConfig,
  textBlockResolveConfig,
};

export type TextBlockConfig = typeof textBlockConfig;
